import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M338.824 903.53V790.587h1242.465V903.53H338.824zm0 338.823v-112.941h903.529v112.94h-903.53zm282.352-903.53c-93.402 0-169.411-76.009-169.411-169.411C451.765 76.009 527.775 0 621.176 0c93.403 0 169.412 76.01 169.412 169.412 0 26.09-6.437 50.484-16.94 72.62L999.98 468.255l-79.962 79.962-226.221-226.334c-22.137 10.504-46.532 16.942-72.622 16.942zm847.06 1444.857v-315.445h315.444l-315.445 315.445zM1016.47 225.882v112.942h790.588v1016.47h-451.765v451.765H112.941V338.824h225.883V225.882H0V1920h1421.478c45.176 0 87.755-17.619 119.717-49.581l329.224-329.11c31.962-32.076 49.581-74.655 49.581-119.831V225.882h-903.53z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoteLine =
/*#__PURE__*/
function (_Component) {
  _inherits(IconNoteLine, _Component);

  function IconNoteLine() {
    _classCallCheck(this, IconNoteLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconNoteLine).apply(this, arguments));
  }

  _createClass(IconNoteLine, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNote",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconNoteLine.displayName = "IconNoteLine";
  return IconNoteLine;
}(Component);

IconNoteLine.glyphName = 'note';
IconNoteLine.variant = 'Line';
IconNoteLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoteLine;
export { IconNoteLine };